"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = (selected, blackThemeStyle, type) => {
    const theme = (0, material_1.useTheme)();
    const tipContainer = Object.assign({ color: theme.qlub.palette.onColorColors.mediumEmphasis, padding: '4px 1rem', fontSize: '1rem', borderRadius: '50px', border: `solid 1px ${theme.qlub.palette.dim.main}`, background: theme.qlub.palette.dim.transparent, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', minHeight: '38px' }, (selected && {
        '> div ': {
            color: type === 'text'
                ? theme.palette.primary.main
                : type === 'number' && blackThemeStyle
                    ? theme.palette.primary.main
                    : theme.qlub.palette.white.main,
        },
        backgroundColor: blackThemeStyle
            ? 'unset'
            : type === 'text'
                ? theme.palette.secondary.main
                : theme.palette.primary.main,
        borderColor: blackThemeStyle ? theme.palette.primary.main : 'transparent',
    }));
    const tipLabel = Object.assign(Object.assign({ flex: '1 1', fontWeight: 'normal', color: theme.qlub.palette.black.main, display: 'flex', alignItems: 'center', justifyContent: 'center' }, (selected && {
        color: theme.qlub.palette.white.main,
    })), { ' > span': {
            display: 'flex',
            alignItems: 'center',
        }, svg: {
            height: '18px',
        } });
    const startIconStyle = {
        position: 'relative',
        height: '20px',
        width: '20px',
        marginRight: '4px',
    };
    const endIconStyle = {
        position: 'relative',
        height: '20px',
        width: '20px',
        marginLeft: '4px',
    };
    return {
        tipContainer,
        tipLabel,
        startIconStyle,
        endIconStyle,
    };
};
exports.default = useStyle;
